import React, { useEffect, useState } from "react";
import ContentCard from "../../common/template/contentCard";
import Select from "../../common/form/select";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button";
import Row from "../../common/layout/row";
import NumberFormat from "react-number-format";
import DateFormat from "../../common/dateFormat/DateFormat";

export function DefinirEnergiaMesForm(props) {
    const [ano, mes, dia] = String(props.dataGrafico).split("-");
    if (!ano || !mes || !dia) return <div style={{ color: "red" }}>Erro ao exibir formulário para incluir leitura</div>;

    const ultimoDiaMesSelecionado = DateFormat.obterUltimoDiaFechadoOuAtualDoMes(ano, mes);
    const formDefault = {
        ano,
        mes,
        dia: ultimoDiaMesSelecionado,
        data_hora: `${ano}-${mes}-${ultimoDiaMesSelecionado} 23:59:59`,
        energia_mes_string: "0",
        energia_mes: 0,
        id_geracao_integracao: props.idGeracaoIntegracao,
    };
    const [form, setForm] = useState(formDefault);
    const [exibirForm, setExibirForm] = useState(false);

    //quando muda o ano do gráfico, troca o ano padrão do form
    useEffect(() => {
        const ultimoDiaMesSelecionado = DateFormat.obterUltimoDiaFechadoOuAtualDoMes(ano, form.mes);
        setForm({
            ...form,
            ano: ano,
            dia: ultimoDiaMesSelecionado,
            data_hora: `${ano}-${form.mes}-${ultimoDiaMesSelecionado} 23:59:59`,
        });
    }, [props.dataGrafico]);

    // gera a lista
    const listaMeses = Array.from({ length: ano == new Date().getFullYear() ? new Date().getMonth() + 1 : 12 }, (_, i) => {
        const valor = i + 1;
        const valorFormatado = (valor < 10 ? "0" : "") + valor;
        return { id: valorFormatado, valor: DateFormat.nomeMeses[i] };
    });

    if (!exibirForm) {
        return (
            <ContentCard style={{ width: "100%", padding: 20 }}>
                <Row alignCenter>
                    <Button
                        text="Definir Energia do Mês"
                        type={"primary"}
                        icon={"fas fa-edit"}
                        event={() => {
                            props.callbackOpenForm();
                            setExibirForm(true);
                        }}
                    />
                </Row>
            </ContentCard>
        );
    }

    return (
        <ContentCard style={{ width: "100%", padding: 20 }}>
            <Row alignCenter>
                <Select
                    name="mes"
                    options={listaMeses}
                    label="Mês"
                    cols="6 6 6 6"
                    placeholder="Selecione o Mês"
                    value={form.data_hora.substring(5, 7)}
                    onChange={(value) => {
                        const ultimoDia = DateFormat.obterUltimoDiaFechadoOuAtualDoMes(form.ano, value);
                        setForm({
                            ...form,
                            mes: value,
                            dia: ultimoDia,
                            data_hora: `${form.ano}-${value}-${ultimoDia} 23:59:59`,
                        });
                    }}
                />

                <Grid cols="6 6 6 6">
                    <label>Energia do Mês ({form.mes + "/" + form.ano})</label>
                    <NumberFormat
                        className="form-control"
                        style={{ height: 40, fontSize: 13, marginBottom:20 }}
                        placeholder={"0"}
                        decimalSeparator={","}
                        decimalScale={2}
                        fixedDecimalScale={2}
                        value={form.energia_mes_string}
                        onValueChange={(values) => {
                            setForm({
                                ...form,
                                energia_mes: values.floatValue,
                                energia_mes_string: values.formattedValue,
                            });
                        }}
                    />
                </Grid>
            </Row>
            <Row alignCenter>
                <Grid cols="6 6 6 6">
                    <Button
                        style={{ margin: 0 }}
                        text="Incluir"
                        type={"success"}
                        icon={"fa fa-check"}
                        event={() => {
                            props.handleSubmit(form);
                            setForm(formDefault);
                            setExibirForm(false);
                            props.callbackCloseForm();
                        }}
                    />
                </Grid>

                <Grid cols="6 6 6 6">
                    <Button
                        style={{ margin: 0 }}
                        text="Cancelar"
                        type={"danger"}
                        icon={"fa fa-times"}
                        event={() => {
                            setForm(formDefault);
                            setExibirForm(false);
                            props.callbackCloseForm();
                        }}
                    />
                </Grid>
            </Row>
        </ContentCard>
    );
}
